<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="50"
    height="58"
    viewBox="0 0 50 58"
  >
    <defs>
      <linearGradient id="vk72ink3mb" x1="0%" x2="100%" y1="50%" y2="50%">
        <stop offset="0%" stop-color="#0750A4" />
        <stop offset="100%" stop-color="#1CA4E0" />
      </linearGradient>
      <path
        id="1tfhbhm02a"
        d="M5.478 2.276c0 .768.854 2.254 1.5 3.267V2.267c0-.39.314-.707.703-.707.387 0 .701.317.701.707 0 .09-.016.175-.045.253L7.181 5.856c.293.448.505.746.505.746s2.21-3.091 2.21-4.326c0-1.234-.991-2.233-2.21-2.233-1.22 0-2.208 1-2.208 2.233m4.767 1.374L8.003 7.713l3.783-2.446c.403-.262.845-.476 1.4-.476l1.264-.005-2.52-1.53c-.216-.132-.444-.19-.661-.19-.435 0-.83.233-1.024.584m-6.803-.395L.922 4.786l1.264.005c.556 0 .998.214 1.4.476L7.37 7.713 5.128 3.65c-.193-.351-.588-.585-1.024-.585-.217 0-.445.06-.662.19m7.97 3.131l-3.25 1.69h7.134l-.81-1.014c-.448-.562-.868-1.105-1.653-1.106-.376 0-.835.125-1.422.43M.887 7.062l-.81 1.014h7.136l-3.25-1.69c-.587-.305-1.047-.43-1.423-.43-.786 0-1.206.544-1.653 1.106"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <path
              fill="#354D99"
              d="M25.499 39.082L32.797 34.821 32.797 43.336 25.499 47.604M34.122 34.066L41.42 29.805 41.42 38.32 34.122 42.588M34.122 24.169L41.42 19.908 41.42 28.423 34.122 32.691M24.359 39.082L17.061 34.821 17.061 43.336 24.359 47.604M15.769 34.066L8.471 29.805 8.471 38.32 15.769 42.588"
              transform="translate(-152 -390) translate(127 369) translate(25 21)"
            />
            <g
              transform="translate(-152 -390) translate(127 369) translate(25 21) translate(17.27 24.572)"
            >
              <mask id="u3qssacrrc" fill="#fff">
                <use xlink:href="#1tfhbhm02a" />
              </mask>
              <path
                fill="url(#vk72ink3mb)"
                d="M5.478 2.276c0 .768.854 2.254 1.5 3.267V2.267c0-.39.314-.707.703-.707.387 0 .701.317.701.707 0 .09-.016.175-.045.253L7.181 5.856c.293.448.505.746.505.746s2.21-3.091 2.21-4.326c0-1.234-.991-2.233-2.21-2.233-1.22 0-2.208 1-2.208 2.233m4.767 1.374L8.003 7.713l3.783-2.446c.403-.262.845-.476 1.4-.476l1.264-.005-2.52-1.53c-.216-.132-.444-.19-.661-.19-.435 0-.83.233-1.024.584m-6.803-.395L.922 4.786l1.264.005c.556 0 .998.214 1.4.476L7.37 7.713 5.128 3.65c-.193-.351-.588-.585-1.024-.585-.217 0-.445.06-.662.19m7.97 3.131l-3.25 1.69h7.134l-.81-1.014c-.448-.562-.868-1.105-1.653-1.106-.376 0-.835.125-1.422.43M.887 7.062l-.81 1.014h7.136l-3.25-1.69c-.587-.305-1.047-.43-1.423-.43-.786 0-1.206.544-1.653 1.106"
                mask="url(#u3qssacrrc)"
              />
            </g>
            <path
              fill="#3AACE1"
              d="M25.593 8.6L32.891 12.869 32.891 4.347 25.593.086zM41.477 9.352L34.179 5.091 34.179 13.606 41.477 17.874M42.65 18.583L49.948 22.851 49.948 14.329 42.65 10.068zM24.355 0L17.057 4.261 17.057 12.783 24.355 8.515 24.355 0zM8.471 9.266L15.769 5.005 15.769 13.52 8.471 17.789M42.65 38.429L49.948 42.697 49.948 34.175 42.65 29.914zM42.65 28.532L49.948 32.8 49.948 24.278 42.65 20.017zM0 14.244L0 22.766 7.298 18.497 7.298 9.983zM0 34.066L0 42.588 7.298 38.32 7.298 29.805z"
              transform="translate(-152 -390) translate(127 369) translate(25 21)"
            />
            <path
              fill="#354D99"
              d="M33.48 14.53L26.223 18.862 33.557 23.047 40.82 18.719M24.916 9.538L17.659 13.87 24.992 18.055 32.256 13.727"
              transform="translate(-152 -390) translate(127 369) translate(25 21)"
            />
            <path
              fill="#3AACE1"
              d="M41.894 39.402L34.637 43.734 41.971 47.919 49.234 43.591M33.48 44.394L26.223 48.726 33.557 52.911 40.82 48.582M17.659 53.587L24.992 57.772 32.256 53.444 24.916 49.255zM16.286 44.394L9.029 48.726 16.363 52.911 23.626 48.582M7.872 39.402L.615 43.734 7.949 47.919 15.212 43.591"
              transform="translate(-152 -390) translate(127 369) translate(25 21)"
            />
            <path
              fill="#354D99"
              d="M16.501 14.53L9.243 18.862 16.577 23.047 23.841 18.719M15.769 24.169L8.471 19.908 8.471 28.423 15.769 32.691"
              transform="translate(-152 -390) translate(127 369) translate(25 21)"
            />
            <path
              fill="#3AACE1"
              d="M0 24.169L0 32.691 7.298 28.423 7.298 19.908z"
              transform="translate(-152 -390) translate(127 369) translate(25 21)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>